import { render, staticRenderFns } from "./DocumentacionNonHistoricalTableFilters.vue?vue&type=template&id=14cda9f6"
import script from "./DocumentacionNonHistoricalTableFilters.vue?vue&type=script&lang=ts"
export * from "./DocumentacionNonHistoricalTableFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports